
const commentStore = (data, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/comment', data, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: { user_str_id: user_str_id ? user_str_id : null }
        }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const commentUpdate = (id, data, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/comment/' + id, data, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: { user_str_id: user_str_id ? user_str_id : null }
        }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const commentDelete = (id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.delete('/api/comment/' + id, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: { user_str_id: user_str_id ? user_str_id : null }
        }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const commentRestore = (id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/comment/restore/' + id, {}, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: { user_str_id: user_str_id ? user_str_id : null }
        }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const commentShow = (id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/comment/' + id, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: {
            	user_str_id: user_str_id ? user_str_id : null
            }
        }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const commentFeed = (id, type, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/comment/feed', {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: {
            	user_str_id: user_str_id ? user_str_id : null,
            	commentable_id: id,
            	commentable_type: type
            }
        }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const commentFeedAccount = (commentable_id, commentable_type, type, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/comment/feed-account', {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: {
				user_str_id: user_str_id ? user_str_id : null,
				commentable_id: commentable_id,
				commentable_type: commentable_type,
				type: type
            }
        }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const commentAccessToken = () => document.location.hash ? document.location.hash.substring(1) : null

const commentVerify = comment_id => {
	return new Promise((resolve, reject) => {
		axios.post('/api/comment/verify/' + comment_id, null, {params: commentAccessToken() ? {comment_access_token: commentAccessToken()} : null}).then(res => resolve(res.data), res => reject(res.response))
	})
}

export {
	commentStore,
	commentUpdate,
	commentDelete,
	commentRestore,
	commentShow,
	commentFeed,
	commentFeedAccount,
	commentVerify
}